module.exports = __webpack_public_path__ + "static/big-dc34efeee2c40813365ecb822e086cb0.png";